import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';

import PageNotFound from '../components/PageNotFound';

import IconArrow from '../components/icons/iconArrow';
import IconPin from '../components/icons/iconPin';
import iconTorii from '../assets/img/common/icon_torii.svg';
import bgPattern from '../assets/img/detail/bg_pattern.png';
import cloud1 from '../assets/img/detail/cloud_1.svg';
import cloud2 from '../assets/img/detail/cloud_2.svg';
import cloud3 from '../assets/img/detail/cloud_3.svg';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import '../assets/scss/pages/detail.scss';

export default function DetailPage() {
  const location = useLocation();

  const templeList = useSelector(state => state.temples.templeData);
  const [templeData, setTempleData] = useState({});
  const [seeMore, setSeeMore] = useState(false);

  useEffect(() => {
    document.body.classList.remove('no-scroll');
  }, []);

  useEffect(() => {
    const currentTempleName = location.pathname.replace('/', '');
    const currentTemple = templeList.find(el => el.name_en === currentTempleName);
    setTempleData(currentTemple);
  }, [location, templeData, templeList]);

  const handleMoreClick = e => {
    e.preventDefault();
    setSeeMore(!seeMore);
  }

  const parseImages = urlString => {
    if (!urlString) return;
    const parsedList = urlString.replace(/\s/g, '').split(',');
    return parsedList;
  }

  if (!templeData) {
    return <PageNotFound />
  }

  return (
    <div className="page-detail">
      <div className="detail">
        <div className="detail__inner">
          <div className="detail__content">
            <div className="detail__head">
              <h1 className="detail__heading">{ templeData.detail_title }</h1>
              <div className="detail__info">
                <div className="detail__location">
                  <div className="detail__name"><p>{ templeData.name_jp }</p></div>
                  <div className="detail__address">
                    { templeData.address && (
                      <>
                      <i><IconPin></IconPin></i>
                      <p>{templeData.address}</p>
                      </>
                    ) }
                  </div>
                </div>
                { templeData.google_map_url && (
                  <div className="detail__btn detail__btn--google">
                    <a href={`${templeData.google_map_url}`} target="_blank" rel="noreferrer"><span>Google Map</span></a>
                  </div>
                ) }
              </div>

              {(templeData.detail_kamisama || templeData.detail_goriyaku) && (
              <div className="detail__highlight">
                <div className="detail__highlight-icon"><img src={iconTorii} alt="" /></div>
                <div className="detail__highlight-text">
                  <p>
                    {templeData.detail_kamisama && (
                      <span>
                        <strong>神さま：</strong>{templeData.detail_kamisama}
                      </span>
                    )}
                    {templeData.detail_goriyaku && (
                      <span>
                        <strong>ご利益：</strong>{templeData.detail_goriyaku}
                      </span>
                    )}
                  </p>
                </div>
              </div>
              )}
            </div>

            <div className="detail__body">
              <div className="detail__block">
                {/* <div className="detail__slider">
                  <Swiper
                    modules={[ Navigation, Pagination ]}
                    slidesPerView={1}
                    loop={true}
                    navigation={{
                      nextEl: '.detail__slider .detail__slider-next',
                      prevEl: '.detail__slider .detail__slider-prev'
                    }}
                    pagination={{
                      el: '.detail__slider .swiper-pagination',
                      clickable: true
                    }}>
                    <SwiperSlide><img src={`/detail_images/${templeData.detail_image_url_1}`} alt="須崎八幡宮" /></SwiperSlide>
                    <SwiperSlide><img src={`/detail_images/${templeData.detail_image_url_1}`} alt="須崎八幡宮" /></SwiperSlide>
                    <SwiperSlide><img src={`/detail_images/${templeData.detail_image_url_1}`} alt="須崎八幡宮" /></SwiperSlide>
                    <SwiperSlide><img src={`/detail_images/${templeData.detail_image_url_1}`} alt="須崎八幡宮" /></SwiperSlide>
                  </Swiper>
                  <div className="detail__slider-nav">
                    <div className="detail__slider-next">
                      <svg viewBox="0 0 31 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.28427 0.715729L29.5685 29L1.28427 57.2843" stroke="#990D00" />
                      </svg>
                    </div>
                    <div className="detail__slider-prev">
                      <svg viewBox="0 0 31 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.28427 0.715729L29.5685 29L1.28427 57.2843" stroke="#990D00" />
                      </svg>
                    </div>
                  </div>
                  <div className="swiper-pagination"></div>
                </div> */}

                {templeData.detail_image_url_1 && (
                  parseImages(templeData.detail_image_url_1).map((imageUrl, i) => (
                    <figure className="detail__image" key={i}>
                      <img src={`${process.env.PUBLIC_URL}/detail_images/${imageUrl}`} alt={templeData.name_jp} />
                    </figure>
                  ))
                )}

                {templeData.detail_text_1 && (
                  <div className="detail__intro">
                    <p>{templeData.detail_text_1}</p>
                  </div>
                )}

                {templeData.detail_image_url_2 && (
                  parseImages(templeData.detail_image_url_2).map((imageUrl, i) => (
                    <figure className="detail__image" key={i}>
                      <img src={`${process.env.PUBLIC_URL}/detail_images/${imageUrl}`} alt={templeData.name_jp} />
                    </figure>
                  ))
                )}

                {templeData.detail_text_2 && (
                  <div className="detail__intro">
                    <p>{templeData.detail_text_2}</p>
                  </div>
                )}
              </div>

              <AnimatePresence>
                {seeMore && (
                  <motion.div
                    className="detail__block"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}>

                    {templeData.more_text_1 && (
                      <div className="detail__textbox">
                        <p>{templeData.more_text_1}</p>
                      </div>
                    )}

                    {templeData.more_image_url_1 && (
                      parseImages(templeData.more_image_url_1).map((imageUrl, i) => (
                        <figure className="detail__image" key={i}>
                          <img src={`${process.env.PUBLIC_URL}/detail_images/${imageUrl}`} alt={templeData.name_jp} />
                        </figure>
                      ))
                    )}

                    {templeData.more_text_2 && (
                      <div className="detail__textbox">
                        <p>{templeData.more_text_2}</p>
                      </div>
                    )}

                    {templeData.more_image_url_2 && (
                      parseImages(templeData.more_image_url_2).map((imageUrl, i) => (
                        <figure className="detail__image" key={i}>
                          <img src={`${process.env.PUBLIC_URL}/detail_images/${imageUrl}`} alt={templeData.name_jp} />
                        </figure>
                      ))
                    )}

                    {templeData.more_text_3 && (
                      <div className="detail__textbox">
                        <p>{templeData.more_text_3}</p>
                      </div>
                    )}
                  </motion.div>
                )}
              </AnimatePresence>

              {(templeData.more_image_url_1 ||
              templeData.more_text_1 ||
              templeData.more_image_url_2 ||
              templeData.more_text_2 ||
              templeData.more_text_3) && (
                <div className="detail__btn detail__btn--more">
                  <a href="#" onClick={handleMoreClick}>
                    <motion.i animate={{ rotate: seeMore ? 180 : 0 }}><IconArrow></IconArrow></motion.i>
                    {seeMore ? <span>閉じる</span> : <span>もっと見る</span>}
                  </a>
                </div>
              )}

              {/* <div className="detail__jimocha">
                <p>この神社の情報を<strong>みんなのジモッチャ</strong>で見てみよう！</p>
                <div className="detail__btn detail__btn--xl"><a href="#"><span>みんなのジモッチャへ</span></a></div>
              </div> */}
            </div>
          </div>
          <div className="detail__pattern" style={{ backgroundImage: `url(${bgPattern})` }}></div>
        </div>

        <div className="detail__cloud detail__cloud--one"><img src={cloud1} alt="" /></div>
        <div className="detail__cloud detail__cloud--two"><img src={cloud2} alt="" /></div>
        <div className="detail__cloud detail__cloud--three"><img src={cloud3} alt="" /></div>
      </div>
    </div>
  );
}